import POSConfigModule from "@/store/modules/pos-config";
import { showGroupSelectDialog } from "@/utils/vue-helpers/group-select-dialog";
import { LogService } from "@/services/logging";
import {
  BelgiumCompanyInfo,
  FranceCompanyInfo,
  GermanyCompanyInfo,
} from "@smeetz/compliance-common/src/lib/interfaces";
import {
  isBelgianCompliant,
  isFrenchCompliant,
  isGermanCompliant,
  isInCompliantCountry,
  isSpanishCompliant,
} from "./compliance";

export async function getGroupInfo() {
  // Build group info needed for receipt
  const groupInfo = {
    name: "",
    address: "",
    street: "",
    country: "",
    registrationNum: "",
    phone: "",
    vatNumber: "",
    exoNumber: "",
    vatId: "",
    vatOnPayment: false,
    label: "",
    companyName: "",
    cif: "",
    region: "",
    province: "",
    city: "",
    zip: "",
    displayName: "",
    siret: "",
    nafCode: "",
    siren: "",
    rcs: "",
    legalForm: "",
    socialCapital: "",
    locationCbe: "",
  };
  if (
    !POSConfigModule.groupInfo ||
    isGermanCompliant.value ||
    isSpanishCompliant.value ||
    isFrenchCompliant.value ||
    // Belgium needs the legal info on every build: the receipt's VAT number,
    // address and establishment unit all come from it, and the throw below
    // would otherwise fire on a device that has not cached it yet.
    isBelgianCompliant.value
  ) {
    try {
      await POSConfigModule.fetchGroupInfo();
    } catch (error) {
      LogService.info("Error fetching group info", { error });
    }
  }
  const info = POSConfigModule.groupInfo;
  if (!info) {
    throw new Error("No group info fetched");
  }

  const { name, registrationNumber, brandingList } = info;
  const branding = brandingList && brandingList[0];
  groupInfo.name = name || "";
  groupInfo.registrationNum = registrationNumber || "";

  if (branding) {
    const { phoneNumber, address, city, zip, vatNumber, exoNumber, country } =
      branding;
    groupInfo.address = `${address || ""} - ${zip || ""} ${city || ""}`;
    groupInfo.street = address || "";
    groupInfo.zip = zip || "";
    groupInfo.city = city || "";
    groupInfo.phone = phoneNumber || "";
    groupInfo.vatNumber = vatNumber || "";
    groupInfo.exoNumber = exoNumber || "";
    groupInfo.exoNumber = exoNumber || "";
    groupInfo.country = country?.name || "";
  }

  const legalInfo = POSConfigModule.companyLegalInfo;
  if (isInCompliantCountry.value && !legalInfo) {
    throw new Error("No company legal info found");
  }
  if (legalInfo && isGermanCompliant.value) {
    const { vatId, vatOnPayment, label, address, companyName, zipCode, town } =
      legalInfo as unknown as GermanyCompanyInfo;
    groupInfo.companyName = companyName || "";
    groupInfo.vatNumber = vatId || "";
    groupInfo.vatOnPayment = vatOnPayment || false;
    groupInfo.label = label || "";
    groupInfo.address = `${address || ""} - ${zipCode || ""} ${town || ""}`;
    groupInfo.street = address || "";
    groupInfo.zip = zipCode || "";
    groupInfo.city = town || "";
  } else if (legalInfo && isSpanishCompliant.value) {
    const { vatId, cif, region, province, city, zip, address, displayName } =
      legalInfo as any; //TODO: check why SpainCompanyInfo does not contain displayName
    groupInfo.displayName = displayName || "";
    groupInfo.vatId = vatId || "";
    groupInfo.address = `${address || ""} - ${zip || ""} ${city || ""}`;
    groupInfo.street = address || "";
    groupInfo.cif = cif || "";
    groupInfo.region = region || "";
    groupInfo.province = province || "";
    groupInfo.city = city || "";
    groupInfo.zip = zip || "";
  } else if (isFrenchCompliant.value && legalInfo) {
    const {
      siret,
      vatId,
      vatOnPayment,
      nafCode,
      siren,
      rcs,
      legalForm,
      socialCapital,
    } = legalInfo as unknown as FranceCompanyInfo;
    groupInfo.siret = siret || "";
    groupInfo.vatId = vatId || "";
    groupInfo.vatOnPayment = vatOnPayment || false;
    groupInfo.nafCode = nafCode || "";
    groupInfo.siren = siren || "";
    groupInfo.rcs = rcs || "";
    groupInfo.legalForm = legalForm || "";
    groupInfo.socialCapital = socialCapital || "";
  } else if (isBelgianCompliant.value && legalInfo) {
    const { vatId, vatOnPayment, label, address, locationCbe } =
      legalInfo as unknown as BelgiumCompanyInfo;
    groupInfo.vatId = vatId || "";
    groupInfo.vatOnPayment = vatOnPayment || false;
    groupInfo.label = label || "";
    // the legal address is the registered one, which is what an FPS receipt
    // must show — not the branding address built above
    groupInfo.address = address || "";
    groupInfo.street = address || "";
    groupInfo.zip = "";
    groupInfo.city = "";
    groupInfo.locationCbe = locationCbe || "";
  }

  return groupInfo;
}

/**
 * Show the SDialog-based group selection modal.
 */
export async function selectUserGroup() {
  return showGroupSelectDialog();
}
